/** @jsxImportSource @emotion/react */
import { Container, Flex, Text, useTheme } from "basis";
import { SvgInline } from "components/SvgInline/SvgInline";
import { EnhancedAccount } from "library/accounts/types";

type Props = {
  account: EnhancedAccount;
};

function AccountHeader({ account }: Props) {
  const theme = useTheme();
  const isCreditCard = account.type === "CREDIT_CARD";
  const isPersonalLoan = account.type === "PERSONAL_LOAN";

  return (
    <Container bg="grey.t05" padding="4">
      <Flex>
        <div css={{ display: "flex", flexShrink: 0 }}>
          {isCreditCard && (
            <SvgInline name="credit-card" width="52" height="44" />
          )}
          {isPersonalLoan && (
            <SvgInline name="personal-loan" width="52" height="44" />
          )}
        </div>
        <div
          css={{
            marginLeft: theme.space[5],
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Text>
            <strong>{account.productName}</strong>
          </Text>
          {isCreditCard && account.credit_card?.linked_card_last4 && (
            <Text textStyle="body2" color="grey.t75">
              Card ending {account.credit_card?.linked_card_last4}
            </Text>
          )}
          {isPersonalLoan && account.account_number && (
            <Text textStyle="body2" color="grey.t75">
              Account number {account.account_number}
            </Text>
          )}
        </div>
      </Flex>
    </Container>
  );
}

export { AccountHeader };
